@if (breadcrumbs$ | async; as breadcrumbs) { @if (breadcrumbs.length > 0) {
<nav aria-label="breadcrumb">
  <ol class="breadcrumb m-0">
    @for (breadcrumb of breadcrumbs; track breadcrumb.label; let last =
    $last) {
    <li
      class="breadcrumb-item"
      [class.active]="last"
      [attr.aria-current]="last ? 'page' : null"
    >
      @if (!last && breadcrumb.routerLink && !breadcrumb.disabled) {
      <a [routerLink]="breadcrumb.routerLink" class="breadcrumb-link">
        @if (breadcrumb.icon) {
        <fa-icon [icon]="breadcrumb.icon" class="me-1"></fa-icon>
        }
        {{ breadcrumb.label }}
      </a>
      } @if (last || !breadcrumb.routerLink || breadcrumb.disabled) {
      <span class="breadcrumb-text">
        @if (breadcrumb.icon) {
        <fa-icon [icon]="breadcrumb.icon" class="me-1"></fa-icon>
        }
        {{ breadcrumb.label }}
      </span>
      }
    </li>
    }
  </ol>
</nav>
} }
